var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"image-row block"},_vm._l((_vm.items),function(image){return _c('li',{key:image,staticClass:"block--column"},[_c('img',{attrs:{"src":image}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }